import * as React from "react";
import { LoadingButton } from "@mui/lab";

export default function UIButton(props) {
  return <LoadingButton {...props}>{props.title}</LoadingButton>;
}
